import { render, staticRenderFns } from "./DocumentField.vue?vue&type=template&id=9378a688"
import script from "./DocumentField.ts?vue&type=script&lang=ts&external"
export * from "./DocumentField.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports